module.exports = __webpack_public_path__ + "media/packs/faq/images/header-img2-d04f5d4abb81e030923ccfe4a54b5ca7.svg";